import {
  ConnectAccountStatus,
  type ConnectAccountStatusValue,
} from '@/lib/enums/ConnectAccountStatus'

type StripeConnectStatusInput = ConnectAccountStatusValue | null | undefined

export const stripeConnectOnboardingStatuses: StripeConnectStatusInput[] = [
  ConnectAccountStatus.NotCreated.Value,
  ConnectAccountStatus.Incomplete.Value,
]

export const stripeConnectAccountStatuses: StripeConnectStatusInput[] = [
  ConnectAccountStatus.PendingVerification.Value,
  ConnectAccountStatus.Restricted.Value,
  ConnectAccountStatus.Verified.Value,
]

export function canUseStripeConnectOnboarding(status: StripeConnectStatusInput): boolean {
  return stripeConnectOnboardingStatuses.includes(status)
}

export function canUseStripeConnectAccount(status: StripeConnectStatusInput): boolean {
  return stripeConnectAccountStatuses.includes(status)
}

export function canShowStripeConnectBanner(status: StripeConnectStatusInput): boolean {
  return canUseStripeConnectAccount(status)
}

type StripeConnectToolsInput =
  | {
      has_full_stripe_dashboard?: boolean
      connect_account?: { account_version?: string | null } | null
    }
  | null
  | undefined

// Dashboardless (v2) accounts use our embedded Stripe tools instead of the Stripe Dashboard.
export function hasDashboardlessStripeTools(stripeConnectStatus: StripeConnectToolsInput): boolean {
  return (
    stripeConnectStatus?.has_full_stripe_dashboard === false &&
    stripeConnectStatus.connect_account?.account_version === 'v2'
  )
}
